import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NiModalComponent } from '../../shared/lib/form/ni-modal/ni-modal.component';
import { NiIconComponent } from '../../shared/lib/form/ni-icon/ni-icon.component';
import { NiButtonComponent } from '../../shared/lib/form/ni-button/ni-button.component';

@Component({
  selector: 'app-registration-success-modal',
  standalone: true,
  imports: [CommonModule, NiModalComponent, NiButtonComponent, NiIconComponent],
  template: `
    <NiFormModal 
      [isOpen]="isOpen" 
      [showCancelIcon]="false" 
      [hasBackdrop]="true" 
      [preventBackdropClose]="true"
      [className]="'max-w-[90%] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[600px] w-full'">
      <div
        class="flex flex-col items-center gap-[2rem] w-full justify-center p-[20px] sm:p-[30px] md:p-[40px] text-center "
      >
        <!-- Success Icon -->
        <div
          class="w-[6.09375rem] h-[6.09375rem] bg-success-900 rounded-full flex items-center justify-center"
        >
          <NiFormIcon icon="submit" iconClass="!w-[4.265625rem] !h-[3.65625rem]"> </NiFormIcon>
        </div>

        <div class="flex flex-col items-center justify-center gap-[1rem] font-archivo max-w-[520px] w-full ">
          <!-- Title -->
          <h2 class="text-[24px] font-bold text-gray-1400 leading-[29px]">Account Created Successfully!</h2>

          <!-- Message -->
          <p class="text-gray-700 leading-[32px] text-[20px]">
          Please Log-In with the registered Email to continue with the program enrollment.
          </p>

          <!-- Log In Button -->
          <NiFormButton
            label="Log In"
            color="primary"
            [fontWeight]="700"
            [fontSize]="18"
            paddingSize="px24_py_14"
            (onClick)="onLogin()"
          />
        </div>
      </div>
    </NiFormModal>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class RegistrationSuccessModalComponent {
  @Input() isOpen: boolean = false;
  @Output() onLoginClick = new EventEmitter<void>();

  onLogin(): void {
    this.onLoginClick.emit();
  }
}

